module.exports = __webpack_public_path__ + "encs/web_store/avpv/img/back.ecf11877.svg";